import { render } from "./FooterWeb.vue?vue&type=template&id=b6e0869a&scoped=true"
import script from "./FooterWeb.vue?vue&type=script&lang=js"
export * from "./FooterWeb.vue?vue&type=script&lang=js"

import "./FooterWeb.vue?vue&type=style&index=0&id=b6e0869a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6e0869a"]])

export default __exports__